import React from "react";
import StoreOrderDetails from "../../components/Store/StoreOrderDetails";

export default function StoreOrderDetailsPage() {
  return <StoreOrderDetails />;
}